import React from 'react';
import { LineChart as RechartsLineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { CustomTooltip } from '../CustomTooltip';
interface LineChartProps {
  data: any[];
  xKey: string;
  yKey: string;
  stroke?: string;
  formatter?: (value: number) => string;
}
export const LineChart: React.FC<LineChartProps> = ({
  data,
  xKey,
  yKey,
  stroke = '#2563eb',
  formatter
}) => {
  return <ResponsiveContainer width="100%" height={300} data-id="element-17">
      <RechartsLineChart data={data} margin={{
      top: 10,
      right: 10,
      left: 0,
      bottom: 20
    }} data-id="element-18">
        <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#f1f5f9" data-id="element-19" />
        <XAxis dataKey={xKey} tick={{
        fontSize: 12,
        fill: '#64748b'
      }} tickLine={false} axisLine={{
        stroke: '#e2e8f0'
      }} data-id="element-20" />
        <YAxis tick={{
        fontSize: 12,
        fill: '#64748b'
      }} tickLine={false} axisLine={{
        stroke: '#e2e8f0'
      }} tickFormatter={formatter} data-id="element-21" />
        <Tooltip content={<CustomTooltip formatter={formatter} data-id="element-23" />} data-id="element-22" />
        <Line type="monotone" dataKey={yKey} stroke={stroke} strokeWidth={2} dot={false} activeDot={{
        r: 6,
        stroke: 'white',
        strokeWidth: 2
      }} data-id="element-24" />
      </RechartsLineChart>
    </ResponsiveContainer>;
};